<template>
    <div class="home" :style="charteVars">
        <div class="bubble" v-for="i in 20" :key="i"></div>
        <div class="centralSphere">
            <img class="sphereImage" :src="homeResource" alt="" @mouseover="hover = true" @mouseout="hover = false">
        </div>
        <div class="sphereText">
            <h4 :style="textStyle" v-html="processText(homeImage.text)"></h4>
            <div style="cursor: pointer;" :style="launchStyle" @click="exitHomePage">
                <img v-if="launchImage" :src="launchImage" alt="" class="launchImage">
                <span v-html="processText(homeImage.launch_text)"></span> <q-icon size="xl" name="navigate_next"></q-icon>
            </div>
        </div>
    </div>
</template>

<style scoped>
.home {
    position: relative;
    height: 100vh;
    overflow: hidden;
    background-color: #1b1e23;
}

.bubble {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    animation: floatBubble 10s infinite;
}

.centralSphere {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -20%);
    width: 300px;
    height: 300px;
    border-radius: 50%;
    overflow: hidden;
}

.sphereImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
}

.sphereImage:hover {
    transform: scale(1.1);
}

.sphereText {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    color: white;
    font-size: 25px;
}

.sphereText h4 {
    white-space: pre-line;
    font-size: var(--expo-title-size, 25px);
    color: var(--expo-title-color, white);
    font-family: var(--expo-title-font, inherit);
    font-weight: var(--expo-title-weight, bold);
}

.sphereText span {
    white-space: pre-line;
}

@keyframes floatBubble {
    0% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-30px);
    }

    100% {
        transform: translateY(0);
    }
}
.launchImage{
    max-height: 100px;
    width: auto;
    object-fit: contain;
    background: transparent;
    margin-right: 8px;
}
</style>

<script>
import { ref, onMounted, computed } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
import { useExhibitStyle } from "../../composables/useExhibitStyle";
import { useHomeLayout } from "../../composables/useHomeLayout";
export default {
    props: ["homeImage", "exhibitIdProps"],
    setup(props, ctx) {
        let homeResource = ref();
        const route = useRoute();
        const { cssVars, load: loadCharte } = useExhibitStyle(route.params.id ?? props.exhibitIdProps);
        const charteVars = computed(() => cssVars());
        const { textStyle, launchStyle } = useHomeLayout(() => props.homeImage);
        let exhibitId = ref();
        const hover = ref(false);
        let launchResource = ref();
        let launchImage = ref();
        const start = async () => {
            console.log(props)
            exhibitId.value = route.params.id ?? props.exhibitIdProps;
            loadCharte();
            await getHomeFile();
            handleBubble();
            await getLaunchResource();
            if(launchResource.value?.launch_image_id) await getLaunchFile();
        };

        const processText = (text) => {
            if (!text) return text;
            return text.replace(/\\n/g, '\n');
        };

        const exitHomePage = () => {
            ctx.emit("exit");
        }

        const getHomeFile = async () => {
            try {
                let name = props.homeImage.name;
                let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                let response = await axios.get(url);
                var base64data = response.data;
                homeResource.value = base64data;
            } catch (error) {
                console.log(error);
            }
        };

        /*async function blobToData(blob, name) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    let content = null;
                    let width = null;
                    let height = null;
                    const extension = name.split(".").pop().toLowerCase();
                    if (["jpg", "jpeg", "png", "gif", "bmp"].includes(extension)) {
                        const image = new Image();
                        image.src = reader.result;
                        image.onload = function () {
                            const aspectRatio = image.width / image.height;
                            width = Math.min(image.width, 200);
                            height = width / aspectRatio;
                            content = {
                                url: image.src,
                                width: width,
                                height: height
                            };
                            resolve(content);
                        };
                    } else if (["mp4", "webm", "avi", "mov", "mkv"].includes(extension)) {
                        const video = document.createElement("video");
                        video.src = URL.createObjectURL(blob);
                        video.addEventListener('loadedmetadata', function () {
                            const aspectRatio = video.videoWidth / video.videoHeight;
                            width = Math.min(video.videoWidth, 300);
                            height = width / aspectRatio;

                            content = {
                                url: video.src,
                                width: width,
                                height: height
                            };
                            resolve(content);
                        })
                    } else if (["mp3", "wav", "ogg", "m4a"].includes(extension)) {
                        content = {
                            url: URL.createObjectURL(blob),
                            width: null,
                            height: null
                        };
                        resolve(content);
                    } else {
                        resolve(content);
                    }
                };
                reader.readAsDataURL(blob);
            });
        }*/

        const handleBubble = () => {
            const bubbles = document.querySelectorAll('.bubble');
            bubbles.forEach(bubble => {
                bubble.style.left = Math.random() * 100 + 'vw';
                bubble.style.top = Math.random() * 100 + 'vh';
                bubble.style.width = Math.random() * (150 - 50) + 50 + 'px';
                bubble.style.height = bubble.style.width;
                bubble.style.animationDuration = Math.random() * (15 - 5) + 5 + 's';
                bubble.addEventListener('mouseover', () => {
                    bubble.style.transform = 'scale(1.5)';
                });
                bubble.addEventListener('mouseout', () => {
                    bubble.style.transform = 'scale(1)';
                });
            });
        }

        const getLaunchFile = async () => {
            try {
                let name = launchResource.value.name;
                let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                let response = await axios.get(url);
                var base64data = response.data;
                launchImage.value = base64data;
            } catch (error) {
                console.log(error);
            }
        };
        const getLaunchResource = async ( )=>{
            try {
                let url = `${process.env.VUE_APP_BASEURL}/launchImage/${exhibitId.value}`;
                let response = await axios.get(url);
                launchResource.value = response.data[0];

            } catch (error) {
                console.log(error);
            }
        }
        onMounted(start);

        return {
            homeResource,
            exhibitId,
            hover,
            launchImage,
            launchResource,
            exitHomePage,
            processText,
            charteVars,
            textStyle,
            launchStyle

        }
    }

}
</script>